import { connect } from 'react-redux'
import React, { Component } from 'react'
import { browserHistory } from 'react-router'
import FaCloudUpload from 'react-icons/lib/fa/cloud-upload'
import { extractFromUrl } from '../../actions'
import { processUploadedFiles } from '../../misc/utilities'
import { isIOs } from '../../misc/selectors'

const mapStateToProps = (state, ownProps) => {
  return {
    ...ownProps,
    ios: isIOs(state),
  }
}


class VideoCreator extends Component {
  render() {
    const { dispatch } = this.props

    return (
      <div className="card video-creator">
        <form
          ref={r => {
            if (r) {
              this.formRef = r
            }
          }}
          style={{ display: 'none' }}
        >
          <input
            key="fileInput"
            type="file"
            multiple={!this.props.ios}
            ref="fileInput"
            onChange={() => {
              const files = this.refs.fileInput.files
              if (!files.length) {
                return
              }
              processUploadedFiles(this.props.dispatch, files, this.props.group)
              .then(() => {
                this.formRef.reset()
              })
            }}
          />
        </form>
        <button
          key="uploadButton"
          className="blue-button"
          onClick={(e) => {
            e.preventDefault()
            this.refs.fileInput.click()
          }}
        >
          <span className="highlight" />
          <span className="text"><FaCloudUpload />  &nbsp; Upload video</span>
        </button>
        <form
          key="clipperForm"
          className="clipper-form"
          onSubmit={(e) => {
            document.activeElement.blur()
            e.preventDefault()
            dispatch(extractFromUrl(e.target.elements[0].value, this.props.groupId))
            browserHistory.push('/clipper')
          }}
        >
          <input
            type="text"
            className="form-control url-input"
            placeholder="Paste a video URL"
            onPaste={(e) => {
              let targetInput = e.target
              setTimeout(() => {
                dispatch(extractFromUrl(targetInput.value, this.props.groupId))
                browserHistory.push('/clipper')
              }, 0)
              // document.activeElement.blur()
              // let clipboardData = e.nativeEvent.clipboardData || window.clipboardData;

              // console.log(clipboardData)
              // let pastedText = clipboardData.getData('Text');
              // console.log(pastedText)

              // if (pastedText) {
              //   dispatch(extractFromUrl(pastedText, this.props.groupId))
              //   browserHistory.push('/clipper')
              // }
            }}
          />
        </form>
      </div>
    )
  }
}

export default connect(mapStateToProps)(VideoCreator)



// WEBPACK FOOTER //
// ./src/app/videos/VideoCreator.js